import { Component } from '@theme/component';

/**
 * Product Card Small Component
 * Handles fade-in animation after header height is calculated
 *
 * @typedef {object} ProductCardSmallRefs
 * @property {HTMLElement} wrapper - Product card sticky wrapper element
 *
 * @extends {Component<ProductCardSmallRefs>}
 */
class ProductCardSmall extends Component {
  connectedCallback() {
    super.connectedCallback();

    const { wrapper } = this.refs;
    if (!wrapper) return;

    // Wait for header height to be calculated
    this.#waitForHeaderHeight();
  }

  /**
   * Wait for header height CSS variable to be set, then show the card
   */
  #waitForHeaderHeight() {
    const { wrapper } = this.refs;
    if (!wrapper || Array.isArray(wrapper)) return;

    const checkHeaderHeight = () => {
      const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-container-height');

      if (headerHeight && headerHeight !== '0px' && headerHeight !== '') {
        // Header height is set, show the card with fade-in
        wrapper.setAttribute('data-ready', '');
      } else {
        // Header height not set yet, check again
        requestAnimationFrame(checkHeaderHeight);
      }
    };

    // Start checking
    checkHeaderHeight();
  }
}

if (!customElements.get('product-card-small')) {
  customElements.define('product-card-small', ProductCardSmall);
}
